import { Box, TabPanel, TabPanels, Tabs } from "@chakra-ui/core";
import React from "react";
import NavBar from "../../../../Components/NavBar/index";
import Resume from "./Resume";
import SubNavBar from "./SubNavBar";
import { useStoreActions, useStoreState } from "easy-peasy";
import Card from "../../../../Components/Card";
import Footer from "../../../../Components/Footer";
import PersonalInfo from "./PersonalInfo";
import Skills from "./Skills";
import ProfessionalDetails from "./ProfessionalDetails";
import Eligibility from "./Eligibility";
import OtherDetails from "./OtherDetails";

function EditProfile() {
  const index = useStoreState((state) => state.profile.index);
  const { setIndex } = useStoreActions((actions) => ({
    setIndex: actions.setIndex,
  }));
  // const { index } = state;
  // const {setIndex, decrement} = actions;
  // const [tabIndex, setTabIndex] =useState(0);
  return (
    <Box>
      <NavBar />
      <Tabs index={index} onChange={(index) => setIndex(index)}>
        <SubNavBar />
        <TabPanels>
          <TabPanel>
            <Card>
              <Resume />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <PersonalInfo />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <Skills />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <ProfessionalDetails />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <Eligibility />
            </Card>
          </TabPanel>
          <TabPanel>
            <Card>
              <OtherDetails />
            </Card>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <Footer />
    </Box>
  );
}

export default EditProfile;
